import { render } from "./TrainingParameters.vue?vue&type=template&id=760f14c3"
import script from "./TrainingParameters.vue?vue&type=script&lang=js"
export * from "./TrainingParameters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__